import { Col, LabeledItem, Row, Space, Title } from "melco-ui";
import { Drawer as DrawerType } from "../../hooks/drawer/useGenericDrawer";
import { useTranslation } from "react-i18next";
import { TransferLicenseUsersList } from "./TransferLicenseUsersList";
import styled from "styled-components";
type TransferLicenseProps = {
  license: any;
  referenceDrawer: DrawerType;
  onCloseDrawer: () => void;
}

const LicenseRecipientWrapper = styled.div`
margin-top:25px;
margin-bottom:25px; 
`

export const TransferLicense: React.FC<TransferLicenseProps> = ({ license, referenceDrawer, onCloseDrawer }) => {
  const { t } = useTranslation();
  const {
    master_name,
    master_user_name,
    assigned_name,
    assigned_user_name,
    serial_number
  } = license;

  const CloseDrawerFn = () => {
    referenceDrawer.closeDrawer()
    onCloseDrawer()
  }
  return (
    <>

      
      <Title level={5}>{t("licenses.basic.detail.transfer.licenseinformation")}</Title>
      <Row gutter={[0, 0]}>

        <Col xs={24} md={12}>
          <Space direction="vertical" size="middle">
            <LabeledItem
              label={t("licenses.basic.detail.form.label.serial_number")}
              content={serial_number ?? ""}
              fallback={t("global.fallback.none")}
            />
            <LabeledItem
              label={t("licenses.basic.detail.form.label.owner")}
              content={<><Row>{master_user_name}</Row><Row>{master_name}</Row></> ?? ""}
              fallback={t("global.fallback.none")}
            />
            <LabeledItem
              label={t("licenses.basic.detail.form.label.assigned_user")}
              content={<><Row>{assigned_user_name}</Row><Row>{assigned_name}</Row></> ?? ""}
              fallback={t("global.fallback.none")}
            />
          </Space>
        </Col>
      </Row>
      <Row>
        <Col xs={24} md={12}>
          <Space direction="vertical" size="middle">
            <LicenseRecipientWrapper>
              <Title level={4}>{t("licenses.basic.detail.transfer.licenserecipient")}</Title>
            </LicenseRecipientWrapper>
          </Space>
        </Col>
      </Row>
      <Row>
        <Col xs={24} md={24}>
      <TransferLicenseUsersList
        license={license}
        onClose={CloseDrawerFn}
      />
      </Col>
      </Row>



    </>
  )
}